import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import { Phases_getInstance39l8b4mzhgwzm as Phases_getInstance_0 } from '../statement/HttpResponsePipeline.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  SetupRequest_instance2zzqkp8zxmw91 as SetupRequest_instance,
  Send_instance1oebf6ttzyqzk as Send_instance,
} from './api/CommonHooks.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  get_coroutineContext1djaai1ellg0c as get_coroutineContext,
  HttpRequest3fsc4149kgwfg as HttpRequest,
} from '../request/HttpRequest.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return LOGGER;
}
var LOGGER;
function get_HttpCallValidator() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return HttpCallValidator;
}
var HttpCallValidator;
function get_ExpectSuccessAttributeKey() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return ExpectSuccessAttributeKey;
}
var ExpectSuccessAttributeKey;
var HttpCallValidatorConfigClass;
function HttpCallValidatorConfig() {
  if (HttpCallValidatorConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.d5q_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.e5q_1 = ArrayList().p2();
        this.f5q_1 = true;
      }
      g5q(block) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.d5q_1.j2(block);
      }
    }
    initMetadataForClass($, 'HttpCallValidatorConfig', HttpCallValidatorConfig);
    HttpCallValidatorConfigClass = $;
  }
  return HttpCallValidatorConfigClass;
}
function HttpResponseValidator(_this__u8e3s4, block) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  _this__u8e3s4.g5l(get_HttpCallValidator(), block);
}
var ExceptionHandlerWrapperClass;
function ExceptionHandlerWrapper() {
  if (ExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ExceptionHandlerWrapper');
    ExceptionHandlerWrapperClass = $;
  }
  return ExceptionHandlerWrapperClass;
}
var RequestExceptionHandlerWrapperClass;
function RequestExceptionHandlerWrapper() {
  if (RequestExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RequestExceptionHandlerWrapper');
    RequestExceptionHandlerWrapperClass = $;
  }
  return RequestExceptionHandlerWrapperClass;
}
function RequestError$install$slambda($handler) {
  return constructCallableReference(($this$intercept, it, $completion) => orPromise($completion, function *($completion) {
    try {
      yield* $this$intercept.p4u($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        var error = yield* $($handler(HttpRequest_0($this$intercept.m4v_1), cause, $completion), $completion);
        if (!(error == null))
          throw error;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 2);
}
var RequestErrorClass;
function RequestError() {
  if (RequestErrorClass === VOID) {
    class $ {
      t5r(client, handler) {
        var tmp = Phases_getInstance().f5p_1;
        client.d5j_1.q4v(tmp, RequestError$install$slambda(handler));
      }
      k5p(client, handler) {
        return this.t5r(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RequestError');
    RequestErrorClass = $;
  }
  return RequestErrorClass;
}
var RequestError_instance;
function RequestError_getInstance() {
  return RequestError_instance;
}
function ReceiveError$install$slambda($handler) {
  return constructCallableReference(($this$intercept, it, $completion) => orPromise($completion, function *($completion) {
    try {
      yield* $this$intercept.p4u($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        var error = yield* $($handler($this$intercept.m4v_1.o5l(), cause, $completion), $completion);
        if (!(error == null))
          throw error;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 2);
}
var ReceiveErrorClass;
function ReceiveError() {
  if (ReceiveErrorClass === VOID) {
    class $ {
      t5r(client, handler) {
        var BeforeReceive = new (PipelinePhase())('BeforeReceive');
        client.e5j_1.p4v(Phases_getInstance_0().l5k_1, BeforeReceive);
        client.e5j_1.q4v(BeforeReceive, ReceiveError$install$slambda(handler));
      }
      k5p(client, handler) {
        return this.t5r(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ReceiveError');
    ReceiveErrorClass = $;
  }
  return ReceiveErrorClass;
}
var ReceiveError_instance;
function ReceiveError_getInstance() {
  return ReceiveError_instance;
}
function HttpRequest_0(builder) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return new (HttpRequest$1())(builder);
}
function HttpCallValidatorConfig$_init_$ref_m1o2g9() {
  return constructCallableReference(() => new (HttpCallValidatorConfig())(), 0, 0, 217, '<init>');
}
function HttpCallValidator$lambda($this$createClientPlugin) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  var responseValidators = reversed($this$createClientPlugin.r5p_1.d5q_1);
  var callExceptionHandlers = reversed($this$createClientPlugin.r5p_1.e5q_1);
  var expectSuccess = $this$createClientPlugin.r5p_1.f5q_1;
  var tmp = SetupRequest_instance;
  $this$createClientPlugin.u5p(tmp, HttpCallValidator$lambda$slambda(expectSuccess));
  var tmp_0 = Send_instance;
  $this$createClientPlugin.u5p(tmp_0, HttpCallValidator$lambda$slambda_0(responseValidators));
  var tmp_1 = RequestError_instance;
  $this$createClientPlugin.u5p(tmp_1, HttpCallValidator$lambda$slambda_1(callExceptionHandlers));
  var tmp_2 = ReceiveError_instance;
  $this$createClientPlugin.u5p(tmp_2, HttpCallValidator$lambda$slambda_2(callExceptionHandlers));
  return Unit_instance;
}
function *invoke$validateResponse(responseValidators, response, $completion) {
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Validating response for request ' + response.v5l().o5l().x5l().toString();
    this_0.r4w(tmp$ret$1);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = responseValidators.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    yield* $(element(response, $completion), $completion);
  }
  return Unit_instance;
}
function *invoke$processException(callExceptionHandlers, cause, request, $completion) {
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Processing exception ' + toString(getKClassFromExpression(cause)) + ' for request ' + request.x5l().toString();
    this_0.s4w(tmp$ret$1, cause);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = callExceptionHandlers.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof ExceptionHandlerWrapper())
      yield* $(element.v5r_1(cause, $completion), $completion);
    else {
      if (element instanceof RequestExceptionHandlerWrapper())
        yield* $(element.u5r_1(cause, request, $completion), $completion);
      else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
function HttpCallValidator$lambda$slambda($expectSuccess) {
  return constructCallableReference((request, $completion) => orPromise($completion, function *($completion) {
    var tmp = get_ExpectSuccessAttributeKey();
    request.c5l_1.e4q(tmp, () => $expectSuccess);
    return Unit_instance;
  }), 1);
}
function HttpCallValidator$lambda$slambda_0($responseValidators) {
  return constructCallableReference(($this$on, request, $completion) => orPromise($completion, function *($completion) {
    var call = yield* $this$on.y5r(request, $completion);
    yield* /*#__NOINLINE__*/invoke$validateResponse($responseValidators, call.q5j(), $completion);
    return call;
  }), 2);
}
function HttpCallValidator$lambda$slambda_1($callExceptionHandlers) {
  return constructCallableReference((request, cause, $completion) => orPromise($completion, function *($completion) {
    var unwrappedCause = unwrapCancellationException(cause);
    yield* /*#__NOINLINE__*/invoke$processException($callExceptionHandlers, unwrappedCause, request, $completion);
    return unwrappedCause;
  }), 2);
}
function HttpCallValidator$lambda$slambda_2($callExceptionHandlers) {
  return constructCallableReference((request, cause, $completion) => orPromise($completion, function *($completion) {
    var unwrappedCause = unwrapCancellationException(cause);
    yield* /*#__NOINLINE__*/invoke$processException($callExceptionHandlers, unwrappedCause, request, $completion);
    return unwrappedCause;
  }), 2);
}
var HttpRequest$1Class;
function HttpRequest$1() {
  if (HttpRequest$1Class === VOID) {
    class $ {
      constructor($builder) {
        this.d5s_1 = $builder;
        this.z5r_1 = $builder.y5k_1;
        this.a5s_1 = $builder.x5k_1.v39();
        this.b5s_1 = $builder.c5l_1;
        this.c5s_1 = $builder.z5k_1.v39();
      }
      v5l() {
        // Inline function 'kotlin.error' call
        var message = 'Call is not initialized';
        throw IllegalStateException().o(toString(message));
      }
      w5l() {
        return this.z5r_1;
      }
      x5l() {
        return this.a5s_1;
      }
      p5l() {
        return this.b5s_1;
      }
      u54() {
        return this.c5s_1;
      }
      p2q() {
        var tmp = this.d5s_1.a5l_1;
        var tmp0_elvis_lhs = tmp instanceof OutgoingContent() ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'Content was not transformed to OutgoingContent yet. Current body is ' + toString(this.d5s_1.a5l_1);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
    }
    protoOf($).ww = get_coroutineContext;
    initMetadataForClass($, VOID, VOID, VOID, [HttpRequest()]);
    HttpRequest$1Class = $;
  }
  return HttpRequest$1Class;
}
var properties_initialized_HttpCallValidator_kt_xrx49w;
function _init_properties_HttpCallValidator_kt__r6yh2y() {
  if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
    properties_initialized_HttpCallValidator_kt_xrx49w = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
    var tmp = HttpCallValidatorConfig$_init_$ref_m1o2g9();
    HttpCallValidator = createClientPlugin('HttpResponseValidator', tmp, HttpCallValidator$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ExpectSuccessAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().yf();
    var tmp_1 = !(null == null) ? typeof null === 'boolean' : false;
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_2;
    try {
      tmp_2 = createKType(PrimitiveClasses_getInstance().yf(), arrayOf([]), false);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_3 = null;
      } else {
        throw $p;
      }
      tmp_2 = tmp_3;
    }
    var tmp$ret$2 = tmp_2;
    var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp_1, tmp$ret$2);
    ExpectSuccessAttributeKey = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: init
RequestError_instance = new (RequestError())();
ReceiveError_instance = new (ReceiveError())();
//endregion
//region block: exports
export {
  get_ExpectSuccessAttributeKey as get_ExpectSuccessAttributeKey20jj5fup38v1g,
  get_HttpCallValidator as get_HttpCallValidator3iji36qylbtbr,
  HttpResponseValidator as HttpResponseValidator2d6ie1tmzg8fi,
};
//endregion

//# sourceMappingURL=HttpCallValidator.mjs.map
